<template>
    <div
        class  = "unit-details"
        :class = "unit.lastInGroup ? 'unit-header-divider ' : ''"
    >
        <!-- Action buttons -->
        <p-assign-buttons
            v-if          = "assignOn"
            :plus-active  = "(!unit.orderId || unit.orderId === order.id) && !isAssigned"
            :minus-active = "isAssigned"
            @plus         = "onAssign"
            @minus        = "onDissolve"
        />

        <p-dispatch-buttons
            v-if          = "dispatchOn"
            :plus-active  = "!isDispatched && !!assignment"
            :minus-active = "isDispatched && (isDisponent || isDispatcher || assignment.technicianIdent === user.ident)"
            :user         = "user"
            @plus         = "onDispatch"
            @minus        = "onRelease"
        />
        <!-- Action buttons -->

        <div class="unit-street-no">
            Nr.{{ unit.number }}
        </div>

        <div class="unit-ident">
            <c-tag
                :label           = "contract"
                :active          = "false"
                :width           = "40"
                :background-color = "assignment && assignment.hasErrors ? 'red' : 'primary'"
            />

            <div
                class="unit-elevator-no"
                :class="active ? 'black--text' : 'lightgray'"
            >
                {{ unit.elevatorNo }}
            </div>

            <div class="inspection-status">
                <v-icon
                    size="18"
                    color="primary"
                >
                    {{ status }}
                </v-icon>
            </div>

            <!-- device type conflict of the app (HCIT-943) -->
            <div v-if="unit.deviceTypeConflict" class="inspection-status" :title="$t('disposition.inspection.deviceType.conflict.title')">
                <v-icon size="18" color="error">mdi-alert-octagon-outline</v-icon>
            </div>
        </div>

        <div class="inspection-user">
            {{ assignedUser }}
        </div>

        <v-spacer/>

        <div class="inspection-date primary--text">
            {{ inspectionDate }}
        </div>

        <!-- elevator lgs icon -->
        <c-lgs-button
            v-if  = "unit['deviceLgSmart']"
            class = "unit-lgs-icon"
            :unit = "unit"
        />
        <!-- elevator lgs icon -->

        <!-- elevator type icon -->
        <c-site-icon
            class="unit-type-icon"
            :site="unit"
            @selected="onEdit"
        />
        <!-- elevator type icon -->
    </div>
</template>

<script>

import Core             from "@/modules/core/service/Core";
import CTag             from "@/modules/core/components/utils/CTag.vue";
import Site             from "@/modules/msd/unit/service/Site";
import CLgsButton       from "@/modules/lis/components/CLgsButton.vue";
import CSiteIcon        from "@/modules/msd/unit/components/controlls/CSiteIcon.vue";
import PAssignButtons   from "@/modules/dis/components/order/common/PAssignButtons.vue";
import PDispatchButtons from "@/modules/dis/components/order/common/PDispatchButtons.vue";
import DispositionSecurityMixin from "@/modules/dis/mixins/DispositionSecurityMixin";

export default {
    name: "PDispositionUnitDetails",

    components: {
        PDispatchButtons,
        PAssignButtons,
        CTag,
        CSiteIcon,
        CLgsButton
    },

    mixins: [
        DispositionSecurityMixin
    ],

    props: {
        order: {

        },

        unit: {

        },

        /**
         * The inspection assignment, if the unit is already assigned to an order.
         */
        assignment: {

        },

        /**
         * True, if the assign mode is switched on.
         */
        assignOn: {

        },

        /**
         * True, if the dispatch mode is switched on.
         */
        dispatchOn: {

        },

        user: {

        }
    },

    computed: {
        active () {
            if (!this.unit.status) {
                return false;
            }

            return this.unit.status.id === 1;
        },

        contract () {
            if (!this.unit.contractLimTypeId) {
                return !this.unit.id ? "NEU" : "P";
            }

            switch (this.unit.contractLimTypeId) {
                case Site.CONTRACT.LIM:
                    return "LIM";
                case Site.CONTRACT.DLS:
                    return "DLS";
            }

            return "P";
        },

        isAssigned () {
            return !!this.assignment
        },

        isDispatched () {
            if (!this.assignment) {
                return false;
            }

            return !!this.assignment.technicianId;
        },

        assignedUser () {
            if (!this.assignment || !this.assignment.technicianName) {
                return "---";
            }

            return this.assignment.technicianName;
        },

        inspectionDate () {
            if (!this.assignment || !this.assignment.inspectionDate) {
                return null;
            }

            return Core.format.date.sdisplay(this.assignment.inspectionDate)
        },

        status () {
            if (!this.assignment) {
                return null;
            }

            if (this.assignment.done) {
                return "mdi-lock"
            }

            if (this.assignment.lastUpload) {
                return "mdi-upload";
            }

            if (this.assignment.download) {
                return "mdi-download";
            }

            return null;
        }
    },

    methods: {
        onAssign () {
            this.unit.order = this.order;
            this.$emit("assign", this.unit)
        },

        onDissolve () {
            this.$emit("dissolve", this.unit)
        },

        onDispatch () {
            this.$emit("dispatch", this.unit)
        },

        onRelease () {
            this.$emit("release", this.unit)
        },

        onEdit () {
            this.$emit("edit", this.unit)
        },
    }
}
</script>

<style scoped>

.unit-details {
    display: flex;
    width: 100%;
    padding-left: 8px;
    height: 32px;
    padding-top: 1px;
}

.unit-ident {
    display: flex;
    padding-top: 3px;
}

.unit-street-no {
    margin-top: 5px;
    width: 50px;
    max-width: 50px;
    text-align: left;
    margin-right: 4px;
    overflow-x: hidden;
    white-space: nowrap;
}

.unit-elevator-no {
    display: flex;
    margin-left: 8px;
    padding-top: 2px;
}

.unit-lgs-icon {
    margin-top: -1px;
    margin-right: 12px;
}

.unit-type-icon {
    margin-top: 1px;
}

.inspection-date {
    padding-top: 4px;
    width: 70px;
    text-align: center;
}

.inspection-user {
    padding-top: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}

.inspection-status {
    margin-right: 4px;
    margin-left: 4px;
    margin-top: -2px;
    width: 20px;
}

.inspection-user, .inspection-date, .unit-street-no, .unit-elevator-no {
    font-size: 13px;
}

</style>